const PageLoading = () => {
    return (
            <div className="ui segment" style={{position: 'absolute', width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.50)'}}>
                <div className="ui active inverted dimmer">
                    <div className="ui large text loader" style={{fontSize: '30px'}}>Loading</div>
                </div>
                <p></p>
                <p></p>
                <p></p>
            </div>
    )
}
export default PageLoading